import styles from "@/components/modal/refer-friend/styles/refer-friend-modal.module.scss";
import { useReferralLink } from "@/hooks/use-referral-link";
import CopyTextBar from "@/components/common/copy/copy-text-bar";
import CopyProvider from "@/hooks/providers/copy-provider";

const ReferFriendModal = () => {
  const { getReferralLink } = useReferralLink();

  return (
    <CopyProvider>
      <div className={styles.wrapper}>
        <div className={styles.header_text}>
          AudioModify is better with friends
        </div>
        <div className={styles.description_text}>
          Share your invite link to earn credits! When your friend signs up and
          purchases any subscription, you&apos;ll receive 100 credits. Use your
          earned credits to increase limits for song generation and custom
          voices.
        </div>
        <div className={styles.referral_link_wrapper}>
          <CopyTextBar text={getReferralLink()} />
        </div>
      </div>
    </CopyProvider>
  );
};

export default ReferFriendModal;
